import { createFileRoute } from '@tanstack/react-router';

import { PortalRenewPage } from '@/modules/portal/pages/PortalRenewPage';

export const Route = createFileRoute('/portal/renew/')({
  component: PortalRenewPage,
});
